import { useCallback } from 'react'
import CheckSmall from 'assets/icons/CheckSmall'
import { IOptionsModel } from 'models/shared.models'
import './styles.scss'

export interface ISydTabChipProps<TTabChip> extends IOptionsModel<TTabChip> {
  selectedValue: TTabChip
  handleSelectValue: (value: TTabChip) => void
}

const SydTabChip = <TTabChip,>({
  label,
  value,
  selectedValue,
  handleSelectValue,
}: ISydTabChipProps<TTabChip>) => {
  const selectTab = useCallback(() => {
    handleSelectValue(value)
  }, [handleSelectValue, value])

  return (
    <div
      className={`syd-tab-chip-component ${value === selectedValue ? 'selected' : ''}`}
      onClick={selectTab}>
      {value === selectedValue && <CheckSmall color="#fff" />}
      <span>{label}</span>
    </div>
  )
}

export default SydTabChip
